import React from 'react';

import WarmTierRepositorySetupText from 'data-tiering/WarmTierRepositorySetupText';
import WarmTierSnapshotsText from 'data-tiering/WarmTierSnapshotsText';
import { Alert } from 'components/bootstrap';
import { Spinner } from 'components/common';

import useDataTiering from './hooks/useDataTiering';

const WarmTierReadinessInfo = () => {
  const { readiness } = useDataTiering();

  if (readiness.isLoading) return <Spinner text="Fetching readiness information..." />;

  const introductionText = 'Your Opensearch Cluster is not configured to use the Warm Tier.';

  const alertText = () => {
    if (!readiness.data?.details.supported_by_search_version) {
      return <p>Your Open Search version does not support Searchable Snapshots.</p>;
    }

    if (!readiness.data?.details.restored_snapshots_assignable) {
      return (
        <>
          <p>{introductionText}</p>
          <WarmTierSnapshotsText />
        </>
      );
    }

    if (readiness.data?.details.supported_repository_types.length === 0) {
      return (
        <>
          <p>{introductionText}</p>
          <WarmTierRepositorySetupText />
        </>
      );
    }

    return null;
  };

  if (readiness.data.ready) {
    return null;
  }

  return (
    <Alert bsStyle="warning" title="Cluster not ready for Warm Tier">
      {alertText()}
    </Alert>
  );
};

export default WarmTierReadinessInfo;
